<template>
  <div
    class="cursor-auto"

    v-click-outside="hide"
    @click.stop="openConfig"
  >
    <div class="relative">
      <span>
        <slot></slot>
      </span>

      <transition
        enter-class="mt-2 opacity-0"
        leave-class="mt-0 opacity-100"
        enter-to-class="mt-0 opacity-100"
        leave-to-class="mt-2 opacity-0"
      >
        <div v-if="show" class="pointer-events-auto duration-150 text-gray-800 space-y-5 border border-gray-200 bg-white w-[30em] shadow-lg absolute left-full top-full z-10 rounded-lg">
          <div class="p-5 pb-0">
            <h3 class="font-bold text-lg">{{ newShop ? 'New physical shop' : 'Update physical shop' }}</h3>

            <label for="cover-photo" class="mt-5 block text-sm font-medium leading-6 text-gray-900">Cover photo</label>
            <div class="mt-2 flex justify-center cursor-pointer hover:bg-gray-50 rounded-md border-2 border-dashed border-gray-300 px-6 pt-5 pb-6" @click="selectingScreenshot = true">
              <div class="space-x-3 flex items-center text-center">
                <svg v-if="!$v.src.$model" class="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true">
                  <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <img v-else :src="$v.src.$model" width="300" height="300" class="object-cover w-[40px] h-[40px] rounded-sm">
                <p>
                  Select or upload a cover photo
                </p>
              </div>
            </div>
          </div>
          <div class="border-t border-gray-200"></div>
          <div class="p-5 py-0">
            <div class="flex space-x-5">
              <div class="grow">
                <label class="block text-sm font-medium text-gray-700">Latitude</label>
                <div class="flex max-w-lg rounded-md shadow-sm w-full mt-1">
                  <input
                    v-model="$v.lat.$model"

                    type="text"
                    name="lat"
                    id="lat"
                    placeholder="52.377956"
                    class="block w-full min-w-0 flex-1 rounded-md border-gray-300 focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                    :class="$v.lat.$error && '!border-red-400 focus:!border-red-500 focus:!ring-red-500'"
                  >
                </div>
                <span v-if="$v.lat.$error" class="text-red-600">Latitude is required</span>
              </div>
              <div class="grow">
                <label class="block text-sm font-medium text-gray-700">Longitude</label>
                <div class="flex max-w-lg rounded-md shadow-sm w-full mt-1">
                  <input
                    v-model="$v.lng.$model"

                    type="text"
                    name="lng"
                    id="lng"
                    placeholder="4.897070"
                    class="block w-full min-w-0 flex-1 rounded-md border-gray-300 focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                    :class="$v.lng.$error && '!border-red-400 focus:!border-red-500 focus:!ring-red-500'"
                  >
                </div>
                <span v-if="$v.lng.$error" class="text-red-600">Longitude is required</span>
              </div>
            </div>
            <div class="mt-5">
              <label class="block text-sm font-medium text-gray-700">Title</label>
              <div class="flex max-w-lg rounded-md shadow-sm w-full mt-1">
                <input
                  v-model="$v.title.$model"

                  type="text"
                  name="title"
                  placeholder="Shop X/Rotterdam"
                  id="title"
                  class="block w-full min-w-0 flex-1 rounded-md border-gray-300 focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                  :class="$v.title.$error && '!border-red-400 focus:!border-red-500 focus:!ring-red-500'"
                >
              </div>
              <span v-if="$v.title.$error" class="text-red-600">Title is required</span>
            </div>
            <div class="mt-5">
              <label class="block text-sm font-medium text-gray-700">Address</label>
              <div class="flex max-w-lg rounded-md shadow-sm w-full mt-1">
                <input
                  v-model="$v.address.$model"

                  type="text"
                  name="address"
                  placeholder="Rotterdam 3011 JA Meent 5"
                  id="address"
                  class="block w-full min-w-0 flex-1 rounded-md border-gray-300 focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                  :class="$v.address.$error && '!border-red-400 focus:!border-red-500 focus:!ring-red-500'"
                >
              </div>
              <span v-if="$v.address.$error" class="text-red-600">Address is required</span>
            </div>
            <div class="mt-5">
              <label class="block text-sm font-medium text-gray-700">Description</label>
              <div class="flex max-w-lg rounded-md shadow-sm w-full mt-1">
                <textarea
                  v-model="$v.description.$model"

                  rows="4"
                  type="text"
                  name="description"
                  placeholder="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,"
                  id="description"
                  class="block w-full min-w-0 flex-1 rounded-md border-gray-300 focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                  :class="$v.description.$error && '!border-red-400 focus:!border-red-500 focus:!ring-red-500'"
                ></textarea>
              </div>
              <span v-if="$v.description.$error" class="text-red-600">Description is required</span>
            </div>
          </div>
          <div class="border-t border-gray-200"></div>
          <div class="p-5 pt-0">
            <p class="text-sm font-medium text-gray-500">Weekday ranges</p>
            <div class="text-sm text-gray-900 mt-1">
              <ul role="list" class="divide-y divide-gray-200 rounded-md border border-gray-200">
                <li
                  v-for="range in $v.ranges.$model"
                  :key="range.id"

                  class="flex items-center justify-between text-sm relative"
                >
                  <div class="flex shrink-0 w-0 flex-1 items-center pr-4 pl-3 pr-4">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-5 w-5 flex-shrink-0 text-gray-400">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5m-9-6h.008v.008H12v-.008zM12 15h.008v.008H12V15zm0 2.25h.008v.008H12v-.008zM9.75 15h.008v.008H9.75V15zm0 2.25h.008v.008H9.75v-.008zM7.5 15h.008v.008H7.5V15zm0 2.25h.008v.008H7.5v-.008zm6.75-4.5h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V15zm0 2.25h.008v.008h-.008v-.008zm2.25-4.5h.008v.008H16.5v-.008zm0 2.25h.008v.008H16.5V15z" />
                    </svg>
                    <input class="ml-3 grow outline-none" v-model="range.day" placeholder="E.g: Monday">
                  </div>
                  <div class="grow ml-4 flex-shrink-0 border-l border-gray-200 py-3 pl-3 pr-4">
                    <input class="outline-none" v-model="range.range" placeholder="E.g: 07:30 - 20:00">
                  </div>

                  <svg @click="deleteRange(range.id)" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="text-gray-500 cursor-pointer hover:text-red-500 absolute top-1/2 -translate-y-1/2 right-0 mr-2 w-4 h-4">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                  </svg>
                </li>
                <li @click="addNewRange" class="flex items-center justify-between cursor-pointer hover:bg-gray-50 transition py-3 pl-3 pr-4 text-sm">
                  <div class="flex w-0 flex-1 items-center text-blue-600">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5">
                      <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zM12.75 9a.75.75 0 00-1.5 0v2.25H9a.75.75 0 000 1.5h2.25V15a.75.75 0 001.5 0v-2.25H15a.75.75 0 000-1.5h-2.25V9z" clip-rule="evenodd" />
                    </svg>
                    <span class="ml-2 w-0 flex-1 truncate">Add new time range</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="flex-shrink-0 border-t border-gray-200 px-5 py-4">
            <div class="flex justify-end space-x-3">
              <button
                type="button"

                class="space-x-2 inline-flex justify-center rounded-md border border-transparent bg-blue-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
                @click="save"
              >
                <span>Save</span>
              </button>
            </div>
          </div>
        </div>
      </transition>


      <transition v-if="show"
        enter-class="opacity-0"
        leave-class="opacity-100"
        enter-to-class="opacity-100"
        leave-to-class="opacity-0"
        mode="out-in"
      >
        <div v-if="selectingScreenshot" class="duration-200 fixed w-full h-full left-0 top-0 z-40 flex justify-center items-center pointer-events-auto" @click.self="selectingScreenshot = false">
          <div class="duration-300 border border-gray-200 bg-white shadow-lg z-40 rounded-lg">
            <ImageManager
              :website-uid="website.uid"
              class="pointer-events-auto"

              @close="selectingScreenshot = false"
              @set-value="selectScreenshot"
            />
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>

import { required } from "vuelidate/lib/validators"
import { mapGetters } from "vuex"

import ImageManager from "@/components/SideEditor/ContainerOptions/ImageManager"

const fields = ['lat', 'lng', 'address', 'title', 'description', 'src', 'ranges']

export default {
  components: {
    ImageManager,
  },
  props: {
    shop: {
      type: Object,
      default: () => ({}),
    },
  },
  validations: {
    ...fields.reduce((obj, field) => ({ ...obj, [field]: { } }), {}),

    lat: { required },
    lng: { required },
  },
  data() {
    return {
      show: false,
      selectingScreenshot: false,

      ...fields.reduce((obj, field) => ({ ...obj, [field]: "" }), {}),
      ranges: [],
    }
  },
  created() {
    fields.forEach(field => {
      this.$v[field].$model = this.shop[field] || ""
    })
    this.$v.$reset()
  },
  methods: {
    deleteRange(id) {
      this.$v.ranges.$model.splice(
        this.$v.ranges.$model.findIndex(item => item.id === id),
        1
      )
      this.$v.ranges.$model = []
    },
    addNewRange() {
      if (!this.$v.ranges.$model) {
        this.$v.ranges.$model = [{ day: "", range: "", id: 'id:' + new Date().getTime() }]
      } else {
        this.$v.ranges.$model.push({ day: "", range: "", id: 'id:' + new Date().getTime() })
      }
    },
    selectScreenshot(src) {
      this.$v.src.$model = src
      this.selectingScreenshot = false
    },
    save() {
      this.$v.$touch()
      if (this.$v.$error) return;

      this.$emit("save", {
        ...fields.reduce((obj, field) => ({ ...obj, [field]: this.$v[field].$model }), {}),

        lat: this.$v.lat.$model.replace(',', '.'),
        lng: this.$v.lng.$model.replace(',', '.'),

        ranges: this.$v.ranges.$model.filter(item => item.day && item.range),
      })
      if (this.newShop) {
        fields.forEach(field => {
          this.$v[field].$model = ""
        })
      }
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          setTimeout(() => {
            this.hide()
          }, 100)
        })
      })
    },

    hide() {
      this.show = false
    },
    openConfig() {
      requestAnimationFrame(() => this.show = true)
    },
  },
  computed: {
    ...mapGetters({
      website: 'editor/website',
    }),

    newShop() {
      return !Object.keys(this.shop).length
    },
  },
}

</script>
